<script setup lang="ts">
const showWarningAlert = ref(true);
</script>

<template>
  <div
    v-if="showWarningAlert"
    :class="$style.warningAlert"
  >
    {{ $t('multiStepRegister.warning_alert') }}
  </div>
</template>

<style module lang="scss">
.warningAlert {
  @apply text-auth-texts/40 text-2xs mt-4 px-0.5 w-full text-center;
}
</style>
